import React from 'react'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { ApiRepository } from 'repository/api-repository'
import { AllergyRepository } from 'repository/repositories/allergy/allergy-repository'
import { RemoteAddAllergy } from 'service/usecases/add-allergy/remote-add-allergy'
import AddAllergy from 'presentation/doctor/pages/AddAllergy'

export default function makeDoctorAddAllergy() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )
  const allergyRepository = new AllergyRepository(apiRepository)

  const addAllergy = new RemoteAddAllergy(allergyRepository)
  return <AddAllergy addAllergy={addAllergy} />
}
